/**
 * The type of bank account.
 */
export type BankAccountType = 'Unspecified' | 'Checking' | 'Savings'

/**
 * The details of a bank account.
 */
export interface BankAccountDetails {
  readonly accountType: BankAccountType
  readonly accountNumber: string
  readonly routingNumber: string
  readonly bankName: string
}

export const BankAccountDetails = {
  /**
   * Empty bank account details.
   */
  empty: {
    accountType: 'Unspecified',
    accountNumber: '',
    routingNumber: '',
    bankName: '',
  } satisfies BankAccountDetails,
}
